import {Box, SvgIcon} from "@mui/material";
import React from "react";

export default function ReloadIcon(props) {
  return(
      <img src="/Icons/reload.svg" alt="reload" {...props}/>
  )
}